import { Component, h, Prop } from '@stencil/core';
import { CmsLinkConfig, Logger } from '../../../global/_types';

@Component({
  tag: 'cms-link-or-button',
  styleUrl: 'cms-link-or-button.scss',
  shadow: false,
})
export class CmsLinkOrButton {
  @Prop() config: string | CmsLinkConfig;
  @Prop() callback: Function;
  @Prop() debug: boolean = false;

  private logger: Logger;

  /* Config */
  private options: CmsLinkConfig;

  componentWillLoad() {
    this.logger = new Logger(this.debug, 'CmsLinkOrButton');
  }

  // Force content update on each render call
  componentWillRender() {
    this.options = typeof(this.config) === 'string' ?
      JSON.parse(this.config) as CmsLinkConfig :
      this.config;
  }

  componentDidLoad() {
    this.logger.trace('CmsLinkOrButton loaded');
  }

  handleClick() {
    if (this.callback) {
      this.callback();
    }
  }

  render() {
    if ((this.options?.link && this.options?.link != "") || this.callback) {
      const isButton = this.options.button !== undefined && Object.keys(this.options.button).length != 0 && !this.options.image;
      const buttonStyle = isButton && this.options.button.bgColor
        ? { backgroundColor: this.options.button.bgColor, borderColor: this.options.button.bgColor }
        : {};
      const buttonLayout = isButton
        ? ' is-button ' + (this.options.button.layout ? this.options.button.layout : ' default')
        : '';
      const buttonIcon = isButton && this.options.button.icon
        ? ' icon ' + this.options.button.icon + (this.options.button.iconPosition ? ' i-' + this.options.button.iconPosition : ' i-left')
        : '';
      const linkIcon = this.options.linkIcon && buttonIcon === ''
        ? ' icon-link icon i-left ' + this.options.linkIcon
        : '';
      const buttonWidth = isButton && this.options.button?.width ? ' custom-width' : '';
      const buttonMargin = isButton && this.options.button?.noMargin ? ' no-margin' : '';
      const linkClass = (this.options.class ? this.options.class : '') + buttonLayout + buttonIcon + linkIcon + buttonWidth + buttonMargin;
      return (
        <div class="container button-container" style={this.options.button?.width ? {width: this.options.button.width} : {}}>
          <a
            href={this.options.link}
            title={this.options.label}
            target={this.options.target}
            class={linkClass}
            style={buttonStyle}
            id={this.options.sectionId}
            data-gtmid={this.options.gtmId}
            download={this.options.dam ? 'download' : null}
            onClick={this.handleClick.bind(this)}
          >
            {
              this.options.label && !this.options.image ?
                this.options.label
                : ""
            }
            {
              !this.options.label && this.options.image && this.options.image.url ?
                <img
                  src={this.options.image.url}
                  alt={this.options.image.caption}
                  width={this.options.image.width}
                  height={this.options.image.height}
                />
                : ""
            }
          </a>
        </div>
      );
    } else {
      return (
        <span>{ this.options?.label ? this.options.label : '' }</span>
      );
    }
  }
}
